var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnnestGroupImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4 11.3H5.6V3.30001H18.4M18.4 1.70001H12L10.4 0.100006H5.6C4.712 0.100006 4 0.812006 4 1.70001V11.3C4 11.7244 4.16857 12.1313 4.46863 12.4314C4.76869 12.7314 5.17565 12.9 5.6 12.9H18.4C18.8243 12.9 19.2313 12.7314 19.5314 12.4314C19.8314 12.1313 20 11.7244 20 11.3V3.30001C20 2.87566 19.8314 2.46869 19.5314 2.16864C19.2313 1.86858 18.8243 1.70001 18.4 1.70001Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.90002 6.4V8H3.20002V10.4L2.47955e-05 7.2L3.20002 4V6.4H7.90002Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnnestGroupImg);
export default __webpack_public_path__ + "static/media/unnest-group-img.fb0d7ea89207540230da66e77441d02a.svg";
export { ForwardRef as ReactComponent };